<template>
    <van-popup v-model:show="show" @close="close" position="center" :close-on-click-overlay="false" :style="{
        minWidth: '80%',
        background: 'transparent',
        color: '#fff',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: '9998'

    }">
        <div class="container" v-if="showIndex === 0">
            <div class="headImage">
                <img class="image1" src="@/assets/theme/bg_bonus_bonus2.png" alt="">
            </div>
            <div class="popupContainer">
                <div class="taskListContainer">
                    <div class="Cardtitle">{{ $t('beRecharge.freeCashback') }}</div>
                    <img class="image2" src="@/assets/theme/i_money.png" alt="">
                    <div class="amountText">{{ formatCurrency(userStore.pendingBackendRecharge?.topUpAmount) }}<span> R$
                        </span></div>
                </div>
                <div class="dashline"></div>
                <div class="claimButton" @click="handleDisplayPopup()">{{ $t('beRecharge.toReceive') }}</div>

            </div>
        </div>

        <div class="container" v-if="showIndex === 1">
            <div class="headImage">
                <!-- <img class="image2" src="@/assets/theme/bg_bonus_bonus.png" alt=""> -->
            </div>
            <div class="configContainer">
                <img v-if="userStore.pendingBackendRecharge?.config?.doublingMethod === 1" width="100%"
                    style="margin-top: -80px;" src="@/assets/theme/mice.png" alt="">
                <div class="ConfigDetailContainer">
                    <!-- Template view -->
                    <div v-if="userStore.pendingBackendRecharge?.config?.doublingMethod === 2">
                        <div class="bonusAmount">
                            R$ {{ formatCurrency(userStore.pendingBackendRecharge?.topUpAmount) }}
                        </div>
                        <div class="secondPopTitle">{{ $t('beRecharge.anotherDeposit') }}</div>
                        <div class="tabelContainer">
                            <van-row class="headBar">
                                <van-col span="11">{{ $t('beRecharge.deposit') }}</van-col>
                                <van-col span="1">.</van-col>
                                <van-col span="11">{{ $t('beRecharge.multiple') }}</van-col>
                            </van-row>
                            <div>
                                <van-row class="tabel_row" v-for="(item, index) in amountTemplates" :key="index" :style="{
                                    backgroundColor: index % 2 === 1 ? '#c5fcce' : '#c2f2f2'
                                }">
                                    <van-col span="12" style="color:#000">{{ formatCurrency(item.amount) }}</van-col>
                                    <van-col span="12" style="color:#ff0000">{{ item.from }}X - {{ item.to }}X</van-col>
                                </van-row>
                            </div>
                        </div>

                        <div class="footerText">{{ $t('beRecharge.footerText') }}</div>
                    </div>
                    <div v-if="userStore.pendingBackendRecharge?.config?.doublingMethod === 1">
                        <div class="headTitle">
                            {{ $t('beRecharge.multiplierRewards') }}
                        </div>
                        <div class="secondPopTitle" style="padding: 15px 0;"> {{ $t('beRecharge.makeDeposit', {
                            value: userStore.pendingBackendRecharge?.config?.rechargeMultiple
                        }) }}</div>
                        <span class="headBar">{{ $t('beRecharge.win') }}</span>
                        <div class="numberText">{{
                            userStore.pendingBackendRecharge?.config?.displayMultiplier === 0
                                ? userStore.pendingBackendRecharge?.config?.availableMultiple
                                : userStore.pendingBackendRecharge?.config?.displayMultiplier === 1
                                    ? userStore.pendingBackendRecharge?.config?.displayFrom + '-' +
                                    userStore.pendingBackendRecharge?.config?.displayTo
                                    : '0' }}</div>
                        <div class="secondPopTitle" style="padding: 5px 0 15px;">{{ $t('beRecharge.bonusTime') }}</div>
                        <div class="footerText">{{ $t('beRecharge.footerText') }}</div>
                    </div>
                </div>
            </div>
            <van-row style="padding: 10%;">
                <van-col span="12" style="padding: 0 10px;">
                    <div class="claimBtn" @click="getClaim">{{ $t('beRecharge.continueToReceive') }}</div>
                </van-col>
                <van-col span="12" style="padding: 0 10px;">
                    <div class="depositBtn" @click="goToDeposit">{{ $t('beRecharge.multipliedReward') }}</div>
                </van-col>
            </van-row>
        </div>

        <div class="closeICon">
            <img class="image1" src="@/assets/theme/i_close.png" alt="" @click="close">
        </div>
    </van-popup>

    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>

<script setup lang="ts">
import { ref, computed, defineExpose, defineEmits, onMounted, provide } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useUserStore } from '@/stores/user'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { handleMenuClick } from '@/view/components/supportFunction'
import { formatCurrency } from '@/utils/commonFunction'
const userStore = useUserStore()
const router = useRouter()
const { t } = useI18n();
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const showIndex = ref(0)
const amountTemplates = ref<any[]>(userStore.pendingBackendRecharge?.config.amountTemplates)
const emits = defineEmits(['handleShowTreasurePopup', 'getClaim', 'getDepositClaim', 'resetShowTreasurePopup'])
const open = () => {
    show.value = true
    showIndex.value = 0
}
const close = () => {
    if (userStore.pendingBackendRecharge?.config.cannotTurnOff == 0) {
        show.value = false
    }
}

const directClose = () => {
    show.value = false
    showIndex.value = 0
}

const handleDisplayPopup = () => {
    if (userStore.pendingBackendRecharge?.config.doubleReward === 0) {
        getClaim()
    } else {
        showIndex.value = 1
    }
}
const goToDeposit = () => {

    router.push({
        path: '/sd-topup',
        query: { batchRecharge: 'true' }
    })
    show.value = false
    localStorage.setItem('showDepositBackIcon', '1')
}
const getClaim = () => {
    emits('getClaim')
}

onMounted(() => {
    setTimeout(() => {
        show.value = true
    }, 3500)
})


defineExpose({ open, close, directClose })
</script>

<style scoped>
.van-popup {
    overflow: visible !important;
}

.container {
    overflow: visible !important;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.popupContainer {
    overflow: visible !important;
    background: linear-gradient(0deg, #002121 0%, #024a49 50%, #73e74e 100%);
    border-radius: 15px;
    min-width: 30%;
    padding: 2% 0;
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    -webkit-mask-image:
        radial-gradient(circle 12px at left 70%, transparent 98%, black 100%),
        radial-gradient(circle 12px at right 70%, transparent 98%, black 100%);
    -webkit-mask-composite: xor;
    mask-composite: intersect;
}


.van-overlay {
    z-index: 9997 !important;
    backdrop-filter: blur(.26667rem);
}

.headImage {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.headImage img {
    width: 80%;
    z-index: 1;
}

.gradient-text {
    font-size: 35px;
    background: linear-gradient(180deg, #23fc9a, #01ff01);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: bold;
    padding: 15px;
    text-align: center;
    margin: 0;
}

.taskListContainer {
    max-height: 30vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.taskListContainer::-webkit-scrollbar {
    display: none;
}

.taskListContainer img {
    width: 40%;
    padding: 10%;
}

.Cardtitle {
    max-width: 60%;
    color: #fff;
    font-weight: 600;
    padding: 0;
    text-align: center;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.amountText {
    font-size: 14px;
    color: #ffa600;
    font-weight: 600;
}

.amountText span {
    font-weight: 200;
    font-size: 10px;
}

.dashline {
    width: 70%;
    border-top: 3px dashed #fff;
    margin: 10% 0;
}

.claimButton {
    border-radius: 10px;
    color: #fff;
    background-image: linear-gradient(90deg, rgb(1, 71, 70) -18%, rgb(15, 177, 175) 122%);
    padding: 8px 10px;
    font-size: 10px;
    font-weight: 600;
    margin: 5%;
    justify-content: center;
    text-align: center;
    width: 60%;
}

.closeICon img {
    width: 50%;
    margin: 15px 0;
}

.closeICon {
    display: flex;
    align-items: center;
    justify-content: center;
}

.configContainer {
    width: 60%;
    background: linear-gradient(0deg, #002121 0%, #024a49 80%, #2c900b 100%);
    border-radius: 15px;
    padding: 10px;
    /* margin-top: -40px; */
}

.ConfigDetailContainer {
    background: #1a1d22;
    border-radius: 15px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
}

.bonusAmount {
    color: #d0f648;
    font-weight: bold;
    font-size: 28px;
}

.secondPopTitle {
    color: #fff;
    border-radius: 300;
    font-size: 16px;
}

.tabelContainer {
    padding: 3%;
}

.headBar {
    color: #fff;
    background: linear-gradient(96deg, #04826d, #029f27 97.21%);
    padding: 5px 10px;
    font-weight: 15px;
    border-radius: 30px;
    font-size: 16px;
    margin-bottom: 10px;
}

.numberText {
    font-size: 35px;
    padding: 10px;
    color: #f140a3;
}

.tabel_row {
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    padding: 3px;
    font-size: 13px;
    font-weight: bold;
}

.footerText {
    color: #6d788d;
    font-size: 13px;
}

.headTitle {
    background-image: linear-gradient(180deg, #ff71ed 0%, #b500f9 100%);
    border-radius: 10px 10px 30px 30px;
    padding: 10px;
    margin-top: -20px;
    font-weight: 800;
    font-size: 20px;

}

.depositBtn {
    color: #fff;
    font-size: 15px;
    background-image: linear-gradient(90deg, rgb(1, 71, 70) -18%, rgb(15, 177, 175) 122%);
    border-radius: 10px;
    padding: 5px 20px;
    height: 100%;
    align-items: center;
    display: flex;
    justify-content: center;
    text-align: center;
}

.claimBtn {
    font-size: 15px;
    color: #fff;
    background-image: linear-gradient(90deg, rgb(1, 71, 70) -18%, rgb(15, 177, 26) 122%);
    border-radius: 10px;
    padding: 5px 20px;
    height: 100%;
    align-items: center;
    display: flex;
    justify-content: center;
    text-align: center;
}
</style>